import { Routes } from '@angular/router';
import { permissionGuard } from '@core/guards';

export const usersRoutes: Routes = [
  {
    path: 'users',
    loadComponent: () =>
      import('@feature/setting/users/users.component').then(
        m => m.UsersComponent
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [permissionGuard('DispatcherSystemUsersView')],
        loadComponent: () =>
          import('./system-users/system-users.component').then(
            m => m.SystemUsersComponent
          ),
      },
      {
        path: 'admin-roles',
        canActivate: [permissionGuard('DispatcherRolesPermissionsView')],
        loadComponent: () =>
          import('./user-roles/user-roles.component').then(
            m => m.UserRolesComponent
          ),
        data: { isAdminPortal: true },
      },
      {
        path: 'customer-roles',
        canActivate: [
          permissionGuard('DispatcherCustomersRolesAndPermissionsView'),
        ],
        loadComponent: () =>
          import('./user-roles/user-roles.component').then(
            m => m.UserRolesComponent
          ),
        data: { isAdminPortal: false },
      },
    ],
  },
];
